/**
 * Логотипы: real SVG via Simple Icons CDN (cdn.simpleicons.org) или локальные файлы в public/de-kleinanzeigen/banks/.
 */

const P = typeof process !== 'undefined' && process.env && process.env.PUBLIC_URL ? process.env.PUBLIC_URL : '';

export function bankLogoSrcLocal(file) {
  return `${P}/de-kleinanzeigen/banks/${file}`;
}

/** @typedef {{ id: string, name: string, simpleIcon?: string, simpleColor?: string, localFile?: string }} KleinBank */

/** @type {KleinBank[]} */
export const KLEINANZEIGEN_BANKS_MODAL = [
  { id: 'sparkasse', name: 'Sparkasse', simpleIcon: 'sparkasse', simpleColor: 'E2001A' },
  { id: 'ing', name: 'ING', localFile: 'ing.svg' },
  { id: 'dkb', name: 'DKB', localFile: 'dkb.svg' },
  { id: 'amazon', name: 'Amazon', localFile: 'amazon.svg' },
  { id: 'postbank', name: 'Postbank', localFile: 'postbank.svg' },
  { id: 'adac', name: 'ADAC', localFile: 'adac.svg' },
  { id: 'miles', name: 'Miles & More', localFile: 'milesandmore.svg' },
  { id: 'targo', name: 'Targobank', localFile: 'targobank.svg' },
  { id: 'barclays', name: 'Barclays', simpleIcon: 'barclays', simpleColor: '00AEEF' },
  { id: 'commerz', name: 'Commerzbank', simpleIcon: 'commerzbank', simpleColor: 'FFCC00' },
];

/** @type {KleinBank[]} */
export const KLEINANZEIGEN_BANKS_MORE = [
  { id: 'n26', name: 'N26', simpleIcon: 'n26', simpleColor: '48AC98' },
  { id: 'vr', name: 'VR', localFile: 'vr.svg' },
  { id: 'deutsche', name: 'Deutsche Bank', simpleIcon: 'deutschebank', simpleColor: '0018A8' },
  { id: 'advanzia', name: 'Advanzia', localFile: 'advanzia.svg' },
  { id: 'comdirect', name: 'ComDirect', localFile: 'comdirect.svg' },
  { id: 'unicredit', name: 'UniCredit', localFile: 'unicredit.svg' },
  { id: 'vw', name: 'Volkswagen Bank', simpleIcon: 'volkswagen', simpleColor: '151F5D' },
  { id: 'consors', name: 'Consors Finanz', localFile: 'consorsfinanz.svg' },
  { id: 'sparda', name: 'Sparda', localFile: 'sparda.svg' },
  { id: 'tf', name: 'TF Bank', localFile: 'tf.svg' },
  { id: 'hanseatic', name: 'Hanseatic', localFile: 'hanseatic.svg' },
  { id: 'santander', name: 'Santander', localFile: 'santander.svg' },
  { id: 'c24', name: 'C24', localFile: 'c24.svg' },
  { id: 'luxtrust', name: 'LuxTrust', localFile: 'luxtrust.svg' },
];

export function resolveBankLogoUrl(bank) {
  if (bank.localFile) return bankLogoSrcLocal(bank.localFile);
  if (bank.simpleIcon) {
    const c = bank.simpleColor || '333333';
    return `https://cdn.simpleicons.org/${bank.simpleIcon}/${c}`;
  }
  return '';
}
